import { createFileRoute } from "@tanstack/react-router";
import { Ticket, Users, QrCode } from "lucide-react";
import { FeaturePage } from "@/components/marketing/FeaturePage";
import { alternateLinkList } from "@/lib/i18n/locale";
import netImg from "@/assets/networking.jpg";
import heroImg from "@/assets/hero-card.webp";

export const Route = createFileRoute("/vi/platform/events")({
  head: () => ({
    meta: [
      { title: "Sự kiện & RSVP — banana.cards" },
      { name: "description", content: "Tạo trang sự kiện, quản lý RSVP và check-in khách ngay cửa — mọi người tham dự lưu vào CRM." },
      { property: "og:title", content: "Sự kiện & RSVP — banana.cards" },
      { property: "og:description", content: "Trang sự kiện, RSVP, check-in QR." },
      { property: "og:image", content: netImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/events", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <FeaturePage
      eyebrow="Sự kiện & RSVP"
      title="Tổ chức sự kiện"
      italic="phát triển network."
      description="Tạo trang sự kiện đẹp trong vài phút. Nhận RSVP, gửi nhắc nhở, check-in khách bằng QR — và mang đi mọi khách tham dự trong CRM."
      heroImage={netImg}
      metrics={[{ v: "Vô hạn", l: "sự kiện" }, { v: "QR", l: "check-in" }, { v: "Auto", l: "vào CRM" }]}
      bullets={[
        { icon: Ticket, title: "Trang sự kiện đẹp", desc: "Trang RSVP có branding, agenda, địa điểm và speaker bios." },
        { icon: Users, title: "Quản lý RSVP", desc: "Duyệt, waitlist hoặc từ chối. Gửi nhắc nhở và cập nhật phút chót trong 1 click." },
        { icon: QrCode, title: "Check-in QR", desc: "Quét khách từ điện thoại — mọi attendance vào CRM." }
      ]}
      deepDives={[
        { eyebrow: "Trang", title: "Trang sự kiện", italic: "thực sự convert.", description: "Trang mobile-first với branding, lịch, speaker và form RSVP — không cần công cụ thứ ba.", image: netImg, reverse: false, points: ["Domain & branding tùy chỉnh", "Block speaker & agenda", "Giới hạn capacity & waitlist", "Hỗ trợ đa ngôn ngữ"] },
        { eyebrow: "Sau sự kiện", title: "Mỗi khách,", italic: "một contact mới.", description: "Khi sự kiện kết thúc, mọi RSVP và check-in vào Banana CRM tag theo sự kiện — sẵn sàng follow-up.", image: heroImg, reverse: true, points: ["Tự tạo contact", "Tag theo sự kiện", "Trigger automation sau sự kiện", "Export CSV & API"] }
      ]}
      howItWorks={[
        { title: "Tạo sự kiện", desc: "Tiêu đề, ngày, địa điểm, form RSVP." },
        { title: "Chia sẻ trang", desc: "Link, QR hoặc thẻ Banana." },
        { title: "Quản lý RSVP", desc: "Duyệt, waitlist, nhắc." },
        { title: "Check-in & follow up", desc: "Quét QR, auto-tag, automate." }
      ]}
      capabilities={["Sự kiện không giới hạn", "Trang sự kiện branded", "Form RSVP & waitlist", "Email nhắc nhở", "Check-in QR", "Giới hạn capacity", "Auto-tag trong CRM", "Automation sau sự kiện"]}
      faq={[
        { q: "Loại sự kiện nào hoạt động với Banana?", a: "Mọi thứ cần trang, RSVP và danh sách khách: meetup, product launch, dinner, workshop, webinar, conference, open house, fundraiser, tiệc." },
        { q: "Có giới hạn capacity và waitlist không?", a: "Có — đặt capacity cứng và Banana tự đẩy RSVP thừa vào waitlist. Khi khách huỷ, người waitlist được promote tự động." },
        { q: "Có bán vé được không?", a: "Có — kết nối Stripe và bán vé nhiều tier với mã giảm giá." },
        { q: "Check-in tại cửa hoạt động thế nào?", a: "Mở app Banana, quét QR của khách, marked attended tức thì." }
      ]}
      outro={{ title: "Tổ chức sự kiện.", italic: "Giữ các contact.", description: "Mỗi RSVP và check-in trở thành mối quan hệ dài hạn." }}
    />
  );
}